import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getUserTravelInfo } from "../CrudAndRedux/ProfileCrud";
import { actions } from "../CrudAndRedux/ProfileRedux";
import TicketInformation from "./TicketInformation";
import TicketsInformation from "./TicketsInformation";
import TravelsSearchCard from "./TravelsSearchCard";

const Travels = (props) => {
  const { state: profileState } = useSelector((state) => ({
    state: state.profile,
  }));

  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  React.useLayoutEffect(() => {
    getUserTravelInfo(authState.user.token)
      .then((res) => {
        dispatch(actions.getUserHistory(res.data));
        dispatch(actions.setMockedData(res.data));
      })
      .catch(() => {
        toast("مشکلی در ارتباط با سرور بوجود آمد");
      });
  }, []);

  return (
    <div className="p-5">
      <TravelsSearchCard />
      {profileState.userHistory ? (
        <>
          {" "}
          <TicketsInformation />
          <TicketInformation />
        </>
      ) : (
        <div className="container">
          <SkeletonTheme
            baseColor="#d9dce6"
            highlightColor="darkgray"
            style={{ marginTop: 20 }}
            className="container"
          >
            <Skeleton
              count={1}
              style={{ height: "5rem", marginBlock: 10, marginTop: 20 }}
            />

            <Skeleton count={5} style={{ height: "10rem", marginBlock: 10 }} />
          </SkeletonTheme>
        </div>
      )}
    </div>
  );
};

export default Travels;
